import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Profile } from 'src/app/shared/models/security/profile';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';
import { HttpParams } from '@angular/common/http';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';

@Injectable({
	providedIn: 'root'
})
export class ProfileService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllProfiles(): Observable<Profile[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.profileUrl}/all`,
			'getAllProfiles'
		);
	}

	addProfile(profile: Profile): Observable<number> {
		console.log(profile);
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.profileUrl}/add`,
			`addProfile`,
			profile
		);
	}

	updateProfile(profile: Profile): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.profileUrl}/update/${profile.id}`,
			`updateProfile`,
			profile
		);
	}

	deleteRole(roleId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.profileUrl}/delete/${roleId}`,
			`deleteRole`
		);
	}

	getRolesMinimal(): Observable<Profile[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.profileUrl}/all`,
			'getAllRoles',
			httpOptions
		);
	}

	getRoleById(roleId: number): Observable<Profile> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.profileUrl}/get/${roleId}`,
			'getRoleById'
		);
	}

	getRolesPageable(
		page: number,
		size: number,
		search: string,
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.profileUrl}`,
			'getRoles',
			//httpOptions
		);
	}
}
